import React from 'react';
import { Form, Card } from 'react-bootstrap';
import toastr from '../../../../toastr';
import Api from '../../../../../services/ApiService';
import ModeComponent from '../../ModeComponent';

export default class ViewStory extends ModeComponent {
  // properties set on each mount
  clockType = 'mechanics';
  defaultFocus = 'roInput';
  mode = 'VS';

  schema = {
    roInput: {
      errorText: 'Valid RO Required',
      label: 'Repair Order',
      required: true,
    },
    opInput: {
      errorText: 'Operation Number Required',
      label: 'Operation',
      required: true,
      regex: /^\d+$/,
    },
  };

  state = {
    roInput: {
      value: '',
      validationState: null,
    },
    opInput: {
      value: '',
      validationState: null,
    },
    opModes: null, // null | [{op: string, desc: string}, ...]
    storyText: null,
  };
  // end properties reset on each mount

  /* View story has its own process action implementation rather than
     the generic process() in its prototype class (ModeComponent) since
     we want to do something client side with the response body and use
     a different UX pattern
  */
  process(userID, password) {
    if (this.validateForm()) {
      // run D3/QM command here (see timeclock.controller.js:processAction())
      const postBody = {
        clockType: this.clockType,
        mode: this.mode,
        params: {
          opInput: this.state.opInput.value,
          roInput: this.state.roInput.value,
        },
        userID,
        password,
      };

      Api.post('timeclock/processaction', postBody)
        .then(res => {
          res = res.data;
          if (res.d3status === 'OK') {
            this.setState({
              storyText: res.d3message,
            });
          } else {
            toastr.error('Error!', res.d3message);
          }
        })
        .catch(error => {
          // should only be network errors here
          console.error(error.message);
        });
    }

    /* The following prevents the modeconductor from popping a result
      toaster and/or resetting the screen.  This makes sense from a UX
      standpoint since viewing a story isn't really an action to process,
      it's more of a report view, and the mode needs to stay on screen.
      The user can press Reset Screen when done.
    */
    return Promise.reject('');
  }

  render() {
    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form horizontal>
            {this.validatedROInput('roInput', opModes => {
              this.setState({ opInput: { value: '', validationState: null }, opModes });
            })}
            {this.validatedOperationInput('opInput', this.state.opModes)}
            {this.state.storyText && <pre>{this.state.storyText}</pre>}
          </Form>
        </Card.Body>
      </Card>
    );
  }
}
